import { Quiz } from "../components/Quiz";
import { FloralOrnament } from "../components/FloralOrnament";

export default function QuizPage() {
  return (
    <div className="fade-in-up" data-testid="quiz-page">
      <section className="relative overflow-hidden border-b border-bl-border hero-bg-gradient">
        <FloralOrnament className="floral-ornament floral-ornament--tr" variant="1" testId="quiz-floral-tr" />
        <FloralOrnament className="floral-ornament floral-ornament--bl" variant="2" testId="quiz-floral-bl" />
        <div className="relative max-w-editorial mx-auto px-6 md:px-10 lg:px-14 py-20 md:py-28">
          <span className="overline">Quiz Beckyliss</span>
          <h1 className="font-serif text-5xl md:text-6xl text-bl-text mt-3 leading-tight text-balance">
            Quel produit Beckyliss vous correspond ?
          </h1>
          <p className="font-serif italic text-xl text-bl-textSoft mt-6 max-w-2xl leading-relaxed">
            Quatre questions pour composer votre routine sur-mesure. Une signature
            beauté, étape par étape.
          </p>
        </div>
      </section>
      <section className="max-w-editorial mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-20">
        <div className="bg-bl-surface border border-bl-border p-8 md:p-12">
          <Quiz inline />
        </div>
      </section>
    </div>
  );
}
